export const getEansCount = (item) => {
  const {
    eans: eansItem,
    product: { eans: eansProduct },
  } = item
  let eans = []
  if (eansItem.hasOwnProperty('sku')) {
    eans.push(...eansItem.eans)
  } else {
    eans.push(...eansItem)
  }

  if (!eans || eans.length === 0) {
    return `Selecionar EAN`
  } else if (eans.length < eansProduct.length) {
    return `${eans.length}/${eansProduct.length}`
  } else if (eans.length >= eansProduct.length) {
    // If an EAN was deleted on the product but remains on the offer, offer's eans >= product's eans
    return 'Todos'
  }
}
